import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseApiService } from './base-api.service';
import { PageEvent } from '@shared/models/PageEvent';
import { PagedResponse } from '@shared/models/PagedResponse';
import { ParamsBuilder } from '@shared/models/ParamsBuilder';
import { User } from '@shared/models/User';

@Injectable()
export class UsersApiService extends BaseApiService {

  // 상세 화면에서 사용하는 필드까지 포함해서 select
  private readonly userSelectFields = [
    'username',
    'sites',
    'groups',
    'enabled',
    'firstName',
    'lastName',
    'systemUser',
    'lastLogin',
    'lastIp',
    'lockUntil',
    'loginFailCount',
    'twoFactorAuth',
  ];

  url = `${this.baseUrl}/users`;

  getUsers(q: string, pageEvent: PageEvent, query?: Record<string, any>): Observable<PagedResponse> {
    const builder = new ParamsBuilder();
    builder.q = q;
    builder.page = pageEvent.page;
    builder.selectFields = this.userSelectFields;
    builder.limit = pageEvent.limit;
    builder.sort = pageEvent.sort;
    if (query) {
      builder.query = query;
    }

    return this.http.get<PagedResponse>(this.url, { params: builder.build() });
  }

  saveUser(user: User): Observable<any> {
    if (user._id) {
      return this.http.patch(`${this.url}/${user._id}`, user);
    } else {
      return this.http.post(`${this.url}`, user);
    }
  }

  setPassword(id: string, newPassword: string): Observable<any> {
    return this.http.post(`${this.url}/${id}/set-password`, { newPassword });
  }

  requestCode(id: string): Observable<any> {
    return this.http.post(`${this.url}/${id}/request-code`, null);
  }
}
